export interface TenderSow {
    template_tender_id : number;
    name : string;
    logo : string;
    color : string;
    cover? : SowCover;
    section? : SowSection[];
    priliminary? : Priliminary[];
}

export const mapTenderSow = (data:any): TenderSow => {
    if(!data){
        throw new Error('Invalied TenderSow type')
    }
    const TenderSows: TenderSow = {
        template_tender_id: data.template_tender_id,
        name: data.name,
        logo: data.logo,
        color: data.color,
        cover: mapSowCover(data.cover),
        section: mapSowSections(data.section),
        priliminary: mapPriliminarys(data.priliminiery),
       
    }

    return TenderSows;

}

export const mapTenderSows = (data: any[]): TenderSow[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid TenderSows data');
    }
  
    return data.map(mapTenderSow);
};


//=========================================================== SOW COVER

export interface SowCover {
    client_name : string;
    project_address : string;
}

export const mapSowCover = (data:any): SowCover => {
    if(!data){
        throw new Error('Invalied SowCover type')
    }
    const SowCovers: SowCover = {
        client_name: data.client_name,
        project_address: data.project_address,
    }

    return SowCovers;

}

export const mapSowCovers = (data: any[]): SowCover[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid SowCovers data');
    }
  
    return data.map(mapSowCover);
};

//=========================================================== SOW SECTION ===========================================================

export interface SowSection {
    section_id : number;
    section_name : string;
    section_no : string;
    sub_section_data : SowSubSection[];
    section_item_data : SowSectionItemData[];
    after_section_no?: number | null; 
    section_amount?: number | null; 
}

export const mapSowSection = (data:any): SowSection => {
    if(!data){
        throw new Error('Invalied SowSection type')
    }
    const SowSections: SowSection = {
        section_id: data.section_id,
        section_name: data.section_name,
        section_no: data.section_no,
        // sub_section_data: [],
        // section_item_data: [],
        sub_section_data: mapSowSubSections(data.sub_section_data),
        section_item_data: mapSowSectionItemDatas(data.section_item_data),
        after_section_no: data.after_section_no || 0,
        section_amount: data.section_amount || 0,
    }

    return SowSections;

}

export const mapSowSections = (data: any[]): SowSection[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid SowSections data');
    }
  
    return data.map(mapSowSection);
};

//=========================================================== SOW SUB SECTION ===========================================================

export interface SowSubSection {
    sub_section_id : number;
    section_id : number;
    sub_section_name : string;
    sub_section_no : string;
    after_sub_section_no? : number | null;
    sub_section_amount? : number | null;
    sub_section_item_data : SowSubSectionItemData[];
}

export const mapSowSubSection = (data:any): SowSubSection => {
    if(!data){
        throw new Error('Invalied SowSubSection type')
    }
    const SowSubSections: SowSubSection = {
        sub_section_id: data.sub_section_id,
        section_id: data.section_id,
        sub_section_name: data.sub_section_name,
        sub_section_no: data.sub_section_no,
        after_sub_section_no: data.after_sub_section_no || 0,
        sub_section_amount: data.sub_section_amount || 0,
        sub_section_item_data: mapSowSubSectionItemDatas(data.sub_section_item_data),
    }

    return SowSubSections;

}

export const mapSowSubSections = (data: any[]): SowSubSection[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid SowSubSections data');
    }
  
    return data.map(mapSowSubSection);
};

//=========================================================== SOW SECTION ITEM DATA ===========================================================

export interface SowSectionItemData {
    item_id : number;
    section_id : number;
    item_name : string;
    item_no : string;
    after_item_no? : number;
    item_amount_total? : number;
    item_amount_data?: SOWAmountInterFace | null; 
}

export const mapSowSectionItemData = (data:any): SowSectionItemData => {
    if(!data){
        throw new Error('Invalied SowSectionItemData type')
    }

    const sOWAmountInterFace: any = {
        unit_no:  0,
        unit_price:  0 ,
        total: 0,
        note: '',
    
    }

    const SowSubSections: SowSectionItemData = {
        item_id: data.item_id,
        section_id: data.section_id,
        item_name: data.item_name,
        item_no: data.item_no,
        after_item_no: data.after_item_no || 0,
        item_amount_total: data.item_amount_total || 0,
        item_amount_data:(data.item_amount_data && data.item_amount_data !== null) ? mapSOWAmountInterFace(data.item_amount_data) : mapSOWAmountInterFace(sOWAmountInterFace)
    }

    return SowSubSections;

}

export const mapSowSectionItemDatas = (data: any[]): SowSectionItemData[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid SowSectionItemDatas data');
    }
  
    return data.map(mapSowSectionItemData);
};

//=========================================================== SOW SUB SECTION ITEM DATA ===========================================================

export interface SowSubSectionItemData {
    item_id : number;
    sub_section_id : number;
    item_name : string;
    item_no : string;
    after_item_no? : number;
    item_amount_data?: SOWAmountInterFace | null
}

export const mapSowSubSectionItemData = (data:any): SowSubSectionItemData => {
    if(!data){
        throw new Error('Invalied SowSubSectionItemData type')
    }

    const sOWAmountInterFace: SOWAmountInterFace = {
        unit_no:  0,
        unit_price:  0 ,
        total: 0,
        note: '',
    
    }

    const SowSubSections: SowSubSectionItemData = {
        item_id: data.item_id,
        sub_section_id: data.sub_section_id,
        item_name: data.item_name,
        item_no: data.item_no,
        after_item_no: data.after_item_no || 0,
        item_amount_data: data.item_amount_data ? mapSOWAmountInterFace(data.item_amount_data) : sOWAmountInterFace
    }

    return SowSubSections;

}

export const mapSowSubSectionItemDatas = (data: any[]): SowSubSectionItemData[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid SowSubSectionItemDatas data');
    }
  
    return data.map(mapSowSubSectionItemData);
};

//=========================================================== PRILIMINARY ===========================================================

export interface Priliminary {
    priliminiery_id : number;
    project_tender_part_id : number;
    ref_number : string;
    item_name : string;
    after_ref_number? : number | null;
    priliminiery_amount_data? : SOWAmountInterFace | null;
}

export const mapPriliminary = (data:any): Priliminary => {
    if(!data){
        throw new Error('Invalied Priliminary type')
    }

    const sOWAmountInterFace: SOWAmountInterFace = {
        unit_no:  0,
        unit_price:  0 ,
        total: 0,
        note: '',
    
    }


    const Priliminary: Priliminary = {
        priliminiery_id: data.priliminiery_id,
        project_tender_part_id: data.project_tender_part_id,
        ref_number: data.ref_number,
        item_name: data.item_name,
        after_ref_number: data.after_ref_number || 0,
        priliminiery_amount_data: data.priliminiery_amount_data !== null && data.priliminiery_amount_data !== undefined ? mapSOWAmountInterFace(data.priliminiery_amount_data) : sOWAmountInterFace
    }

    return Priliminary;

}

export const mapPriliminarys = (data: any[]): Priliminary[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Priliminarys data');
    }
  
    return data.map(mapPriliminary);
};

//========================================= AMOUNT DATA ===========================================================
export interface SOWAmountInterFace {
    unit_no: number;
    unit_price: number;
    total: number;
    note: string;
}

// export const mapSOWAmountInterFace = (data:any): SOWAmountInterFace => {
//     if(!data){
//         throw new Error('Invalied SOWAmountInterFace type')
//     }

//     const itemAmountData = data ?? {};


//     const SOWAmountInterFace: SOWAmountInterFace = {
//         unit_no: itemAmountData.unit_no ?? 0,
//         unit_price: itemAmountData.unit_price ?? 0 ,
//         total: itemAmountData.total ?? 0,
//         note: itemAmountData.note ?? '',    
//     }

//     return SOWAmountInterFace;

// }


// to single object maping
export const mapSOWAmountInterFace = (data:any): SOWAmountInterFace => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: SOWAmountInterFace ={
        unit_no: data.unit_no,
        unit_price: data.unit_price,
        total: data.total,
        note: data.note,
      
    }
    return res;
}




//=============================== RETURN TYPE - SOW SECTION AND PRILIMINARY ========================================
export interface SectionAndPriliminaryType {
    sowSection: SowSection[];
    priliminary: Priliminary[]
}

